const config = {
  development: {
    DIRECT_UPLOAD_BUCKET: '867089416966-gg-web-stg-attachments',
    CONTENT_URL: "https://attachments-staging.govoutreach.com",
    ATTACHMENTS_URL: "https://attachments.govoutreach.com",
    GOOGLE_MAP_KEY: "",
    GOOGLE_GEOCODING_KEY: "AIzaSyDU1L0LwwZGDEOK7BfzwWiEwDN61pxOWxs",
    GOGOV_WEB_API_URL: "https://user.staging.govoutreach.com",
    GOGOV_WEB_URL: "https://user.staging.govoutreach.com",
    GOGOV_MOBILE_URL: "https://m.staging.govoutreach.com",
    CITIZEN_API_URL: "https://api.staging.govoutreach.com/citizen",
    IDENTITY_API_URL: "https://api.staging.govoutreach.com/users",
    PRODUCTS_API_URL: "https://api.staging.govoutreach.com/products",
    ADMIN_API_URL: "https://api.staging.govoutreach.com/admin",
    CALENDARS_API_URL: "https://api.staging.govoutreach.com/calendars",
    CLIENTS_API_URL: "https://api.staging.govoutreach.com/clients",
    DIRECT_UPLOAD_API_URL: "https://api.staging.govoutreach.com/uploads",
    EMPLOYEES_API_URL: "https://api.staging.govoutreach.com/employees",
    DEPARTMENTS_API_URL: "https://api.staging.govoutreach.com/departments",
    SEARCH_API_URL: "https://api.staging.govoutreach.com/search",
    CRM_TOPICS_API_URL: "https://api.staging.govoutreach.com/crm_topics",
    CRM_STATUSES_API_URL: "https://api.staging.govoutreach.com/crm/statuses",
    CRM_CUSTOM_FIELDS_API_URL: "https://api.staging.govoutreach.com/crm/custom-fields",
    CRM_REQUESTS_API_URL: "https://api.staging.govoutreach.com/crm/requests",
    NOTIFICATIONS_API_URL: "https://api.staging.govoutreach.com/notifications",
    CE_SETTINGS_API_URL: "https://api.staging.govoutreach.com/admin/code",
    CE_STATUSES_API_URL: "https://api.staging.govoutreach.com/ce/statuses",
    CE_VIOLATION_TYPES_API_URL: "https://api.staging.govoutreach.com/ce/violation-types",
    CE_PROPERTIES_API_URL: "https://api.staging.govoutreach.com/ce/properties",
    CE_CASES_API_URL: "https://api.staging.govoutreach.com/ce/cases",
    CE_CUSTOM_FIELDS_API_URL: "https://api.staging.govoutreach.com/ce/custom-fields",
    CE_LETTERS_API_URL: "https://api.staging.govoutreach.com/ce/letters",
    CE_TOPICS_API_URL: "https://api.staging.govoutreach.com/ce_topics",
    PERMITS_CUSTOM_FIELDS_API_URL: "https://api.staging.govoutreach.com/permits/custom-fields",
    PERMITS_FORMS_API_URL: "https://api.staging.govoutreach.com/permits/forms",
    PERMITS_TYPES_API_URL: "https://api.staging.govoutreach.com/permits/types",
    PERMITS_API_URL: "https://api.staging.govoutreach.com/permits",
    PAYMENTS_API_URL: "https://api.staging.govoutreach.com/payments",
    FEE_SCHEDULES_API_URL: "https://api.staging.govoutreach.com/fee-schedules",
    GOAUTOMATION_API_URL: "https://api.staging.govoutreach.com/automation",
    FEATURE_FLAGS_API_URL: "https://api.staging.govoutreach.com/legacy/api/feature_flags.php",
    SYSTEM_STATUS_URL: "https://status-staging.govoutreach.com/cachet/public",
    ASSETS_URL: "https://assets-staging.govoutreach.com",
    SENTRY_DSN: "https://143adbbe09b44249bb1c406a01b0fdac@o396450.ingest.sentry.io/5252806",
    LOGROCKET_SLUG: "s5ctc4/web-app-staging-cxc5n",
    STRIPE_PUBLIC_KEY: "pk_test_51Ij9KVDsqRmHarDvH3TkwaDO8qWMYQX4HHvOaYcwHw778vkslbRnsFMRzv5YOCVhl8AwZBMZrCfLv94Cq3nyB5te00pa1TI5fg"
  },
  staging: {
    DIRECT_UPLOAD_BUCKET: '867089416966-gg-web-stg-attachments',
    CONTENT_URL: "https://attachments-staging.govoutreach.com",
    ATTACHMENTS_URL: "https://attachments.govoutreach.com",
    GOOGLE_GEOCODING_KEY: "AIzaSyDU1L0LwwZGDEOK7BfzwWiEwDN61pxOWxs",
    GOOGLE_MAP_KEY: "AIzaSyCIVurGluwQdJ8rvPltx8oRIzc76D3oAQk",
    GOGOV_WEB_API_URL: "https://user.staging.govoutreach.com",
    GOGOV_WEB_URL: "https://user.staging.govoutreach.com",
    GOGOV_MOBILE_URL: "https://m.staging.govoutreach.com",
    CITIZEN_API_URL: "https://api.staging.govoutreach.com/citizen",
    IDENTITY_API_URL: "https://api.staging.govoutreach.com/users",
    PRODUCTS_API_URL: "https://api.staging.govoutreach.com/products",
    ADMIN_API_URL: "https://api.staging.govoutreach.com/admin",
    CALENDARS_API_URL: "https://api.staging.govoutreach.com/calendars",
    CLIENTS_API_URL: "https://api.staging.govoutreach.com/clients",
    DIRECT_UPLOAD_API_URL: "https://api.staging.govoutreach.com/uploads",
    EMPLOYEES_API_URL: "https://api.staging.govoutreach.com/employees",
    DEPARTMENTS_API_URL: "https://api.staging.govoutreach.com/departments",
    SEARCH_API_URL: "https://api.staging.govoutreach.com/search",
    GOAUTOMATION_API_URL: "https://api.staging.govoutreach.com/automation",
    CRM_TOPICS_API_URL: "https://api.staging.govoutreach.com/crm_topics",
    CRM_STATUSES_API_URL: "https://api.staging.govoutreach.com/crm/statuses",
    CRM_REQUESTS_API_URL: "https://api.staging.govoutreach.com/crm/requests",
    CRM_CUSTOM_FIELDS_API_URL: "https://api.staging.govoutreach.com/crm/custom-fields",
    CE_SETTINGS_API_URL: "https://api.staging.govoutreach.com/admin/code",
    CE_STATUSES_API_URL: "https://api.staging.govoutreach.com/ce/statuses",
    CE_VIOLATION_TYPES_API_URL: "https://api.staging.govoutreach.com/ce/violation-types",
    CE_PROPERTIES_API_URL: "https://api.staging.govoutreach.com/ce/properties",
    CE_CASES_API_URL: "https://api.staging.govoutreach.com/ce/cases",
    CE_CUSTOM_FIELDS_API_URL: "https://api.staging.govoutreach.com/ce/custom-fields",
    CE_LETTERS_API_URL: "https://api.staging.govoutreach.com/ce/letters",
    CE_TOPICS_API_URL: "https://api.staging.govoutreach.com/ce_topics",
    PERMITS_CUSTOM_FIELDS_API_URL: "https://api.staging.govoutreach.com/permits/custom-fields",
    PERMITS_FORMS_API_URL: "https://api.staging.govoutreach.com/permits/forms",
    PERMITS_TYPES_API_URL: "https://api.staging.govoutreach.com/permits/types",
    PERMITS_API_URL: "https://api.staging.govoutreach.com/permits",
    PAYMENTS_API_URL: "https://api.staging.govoutreach.com/payments",
    FEE_SCHEDULES_API_URL: "https://api.staging.govoutreach.com/fee-schedules",
    NOTIFICATIONS_API_URL: "https://api.staging.govoutreach.com/notifications",
    FEATURE_FLAGS_API_URL: "https://api.staging.govoutreach.com/legacy/api/feature_flags.php",
    ASSETS_URL: "https://assets-staging.govoutreach.com",
    SYSTEM_STATUS_URL: "https://status-staging.govoutreach.com/cachet/public",
    SENTRY_DSN: "https://143adbbe09b44249bb1c406a01b0fdac@o396450.ingest.sentry.io/5252806",
    LOGROCKET_SLUG: "s5ctc4/web-app-staging-cxc5n",
    STRIPE_PUBLIC_KEY: "pk_test_51Ij9KVDsqRmHarDvH3TkwaDO8qWMYQX4HHvOaYcwHw778vkslbRnsFMRzv5YOCVhl8AwZBMZrCfLv94Cq3nyB5te00pa1TI5fg"
  },
  production: {
    DIRECT_UPLOAD_BUCKET: '331447492604-gg-web-prod-attachments',
    CONTENT_URL: 'https://content.govoutreach.com',
    ATTACHMENTS_URL: "https://attachments.govoutreach.com",
    GOOGLE_GEOCODING_KEY: "AIzaSyC48hA-wwW2JTOFU5arMte7UJyLgd_RqAY",
    GOOGLE_MAP_KEY: "AIzaSyCIVurGluwQdJ8rvPltx8oRIzc76D3oAQk",
    GOGOV_WEB_API_URL: "https://user.govoutreach.com",
    GOGOV_WEB_URL: "https://user.govoutreach.com",
    GOGOV_MOBILE_URL: "https://m.govoutreach.com",
    CITIZEN_API_URL: "https://api.govoutreach.com/citizen",
    PRODUCTS_API_URL: "https://api.govoutreach.com/products",
    IDENTITY_API_URL: "https://api.govoutreach.com/users",
    ADMIN_API_URL: "https://api.govoutreach.com/admin",
    CALENDARS_API_URL: "https://api.govoutreach.com/calendars",
    CLIENTS_API_URL: "https://api.govoutreach.com/clients",
    DIRECT_UPLOAD_API_URL: "https://api.govoutreach.com/uploads",
    EMPLOYEES_API_URL: "https://api.govoutreach.com/employees",
    DEPARTMENTS_API_URL: "https://api.govoutreach.com/departments",
    SEARCH_API_URL: "https://api.govoutreach.com/search",
    GOAUTOMATION_API_URL: "https://api.govoutreach.com/automation",
    CRM_TOPICS_API_URL: "https://api.govoutreach.com/crm_topics",
    CRM_STATUSES_API_URL: "https://api.govoutreach.com/crm/statuses",
    CRM_CUSTOM_FIELDS_API_URL: "https://api.govoutreach.com/crm/custom-fields",
    CRM_REQUESTS_API_URL: "https://api.govoutreach.com/crm/requests",
    CE_SETTINGS_API_URL: "https://api.govoutreach.com/admin/code",
    CE_VIOLATION_TYPES_API_URL: "https://api.govoutreach.com/ce/violation-types",
    CE_STATUSES_API_URL: "https://api.govoutreach.com/ce/statuses",
    CE_PROPERTIES_API_URL: "https://api.govoutreach.com/ce/properties",
    CE_CASES_API_URL: "https://api.govoutreach.com/ce/cases",
    CE_CUSTOM_FIELDS_API_URL: "https://api.govoutreach.com/ce/custom-fields",
    CE_LETTERS_API_URL: "https://api.govoutreach.com/ce/letters",
    CE_TOPICS_API_URL: "https://api.govoutreach.com/ce_topics",
    PERMITS_CUSTOM_FIELDS_API_URL: "https://api.govoutreach.com/permits/custom-fields",
    PERMITS_FORMS_API_URL: "https://api.govoutreach.com/permits/forms",
    PERMITS_TYPES_API_URL: "https://api.govoutreach.com/permits/types",
    PERMITS_API_URL: "https://api.govoutreach.com/permits",
    PAYMENTS_API_URL: "https://api.govoutreach.com/payments",
    FEE_SCHEDULES_API_URL: "https://api.govoutreach.com/fee-schedules",
    NOTIFICATIONS_API_URL: "https://api.govoutreach.com/notifications",
    FEATURE_FLAGS_API_URL: "https://api.govoutreach.com/legacy/api/feature_flags.php",
    ASSETS_URL: "https://assets.govoutreach.com",
    SYSTEM_STATUS_URL: "https://status.govoutreach.com/cachet/public",
    SENTRY_DSN: "https://ac20efc379254bd58c674f2f25978496@o396450.ingest.sentry.io/5249806",
    LOGROCKET_SLUG: "s5ctc4/web-app-production",
    STRIPE_PUBLIC_KEY: "pk_live_51IkZA1Fe4VpqOTed7ixW3CZZeBiMtpv0N4YIDbw4r4LPFIqF3j6cBSZ8wnGYDCcFDyhU1bc5gGeYqjvuf3WBjXcO00q0r8oyCH"
  }
}

export default {
  ...config[process.env.REACT_APP_STAGE || 'development']
};
